/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookPublicEventPayload } from '../models/BookPublicEventPayload';
import type { CreateCheckoutOrderPayload } from '../models/CreateCheckoutOrderPayload';
import type { CreateStripeCheckoutSessionPayload } from '../models/CreateStripeCheckoutSessionPayload';
import type { PublicEventClaimPayload } from '../models/PublicEventClaimPayload';
import type { PublicEventClaimResponse } from '../models/PublicEventClaimResponse';
import type { PublicEventsResponse } from '../models/PublicEventsResponse';
import type { PublicPaymentConfiguration } from '../models/PublicPaymentConfiguration';
import type { PublicPayPalClientToken } from '../models/PublicPayPalClientToken';
import type { PublicPayPalOrder } from '../models/PublicPayPalOrder';
import type { PublicStripeCheckoutSession } from '../models/PublicStripeCheckoutSession';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EventsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param therapistUuid
     * @param fingerprint Fingerprint of the anonymous user. Required
     * @param includeSubusers Include events from subusers (managed users) of the therapist. Optional, defaults to false
     * @param end End date to filter for. Optional
     * @param start Start date to filter for. Optional
     * @param categories Comma-separated list of event category IDs to filter for. Optional
     * @returns PublicEventsResponse
     * @throws ApiError
     */
    public eventsControllerGetPublicEvents(
        therapistUuid: string,
        fingerprint: string,
        includeSubusers?: boolean,
        end?: string,
        start?: string,
        categories?: string,
    ): CancelablePromise<PublicEventsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/events/{therapistUUID}',
            path: {
                'therapistUUID': therapistUuid,
            },
            query: {
                'fingerprint': fingerprint,
                'includeSubusers': includeSubusers,
                'end': end,
                'start': start,
                'categories': categories,
            },
        });
    }
    /**
     * @param therapistUuid
     * @param requestBody
     * @returns PublicEventClaimResponse
     * @throws ApiError
     */
    public eventsControllerClaimPublicEvent(
        therapistUuid: string,
        requestBody: PublicEventClaimPayload,
    ): CancelablePromise<PublicEventClaimResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/events/{therapistUUID}/claim',
            path: {
                'therapistUUID': therapistUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public eventsControllerOptionsClaimPublicEvent(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/events/{therapistUUID}/claim',
        });
    }
    /**
     * @param therapistUuid
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public eventsControllerUnclaimPublicEvent(
        therapistUuid: string,
        requestBody: PublicEventClaimPayload,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/events/{therapistUUID}/unclaim',
            path: {
                'therapistUUID': therapistUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public eventsControllerOptionsUnclaimPublicEvent(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/events/{therapistUUID}/unclaim',
        });
    }
    /**
     * @param therapistUuid
     * @returns PublicPaymentConfiguration
     * @throws ApiError
     */
    public eventsControllerGetPaymentConfiguration(
        therapistUuid: string,
    ): CancelablePromise<PublicPaymentConfiguration> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/events/{therapistUUID}/payment-configuration',
            path: {
                'therapistUUID': therapistUuid,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public eventsControllerOptionsPaymentConfiguration(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/events/{therapistUUID}/payment-configuration',
        });
    }
    /**
     * @param therapistUuid
     * @returns PublicPayPalClientToken
     * @throws ApiError
     */
    public eventsControllerGetPayPalClientToken(
        therapistUuid: string,
    ): CancelablePromise<PublicPayPalClientToken> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/events/{therapistUUID}/paypal-client-token',
            path: {
                'therapistUUID': therapistUuid,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public eventsControllerOptionsPayPalClientToken(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/events/{therapistUUID}/paypal-client-token',
        });
    }
    /**
     * @param therapistUuid
     * @param requestBody
     * @returns PublicPayPalOrder
     * @throws ApiError
     */
    public eventsControllerCreateCheckoutOrder(
        therapistUuid: string,
        requestBody: CreateCheckoutOrderPayload,
    ): CancelablePromise<PublicPayPalOrder> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/events/{therapistUUID}/create-checkout-order',
            path: {
                'therapistUUID': therapistUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public eventsControllerOptionsCreateCheckoutOrder(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/events/{therapistUUID}/create-checkout-order',
        });
    }
    /**
     * @param therapistUuid
     * @param requestBody
     * @returns PublicStripeCheckoutSession
     * @throws ApiError
     */
    public eventsControllerCreateCheckoutSession(
        therapistUuid: string,
        requestBody: CreateStripeCheckoutSessionPayload,
    ): CancelablePromise<PublicStripeCheckoutSession> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/events/{therapistUUID}/create-checkout-session',
            path: {
                'therapistUUID': therapistUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public eventsControllerOptionsCreateCheckoutSession(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/events/{therapistUUID}/create-checkout-session',
        });
    }
    /**
     * @param therapistUuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public eventsControllerBookPublicEvent(
        therapistUuid: string,
        requestBody: BookPublicEventPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/events/{therapistUUID}/book',
            path: {
                'therapistUUID': therapistUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public eventsControllerOptionsBookPublicEvent(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/events/{therapistUUID}/book',
        });
    }
}
